import React from 'react';
import { SHARE_TEMPLATES } from '../../constants/shareTemplates';

/**
 * Three square thumbnails, RING · STREAK · MARQUEE; the selected one has a 2px border. `renderPreview(key)`
 * draws the real card from the client renderers, already scaled to fit `size`.
 */
export default function ShareTemplatePicker({ value, onChange, kind = 'story', renderPreview = null, size = 88, onDark = true }) {
  const ink = onDark ? '#fff' : '#000';
  return (
    <div role="radiogroup" aria-label="Card template" data-testid={`share-template-${kind}`} style={{ display: 'flex', gap: 8 }}>
      {SHARE_TEMPLATES.map(([key, label]) => {
        const on = value === key;
        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(key)}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: 0, border: 0, background: 'none', color: ink, fontFamily: 'inherit', cursor: 'pointer' }}
          >
            <span style={{ display: 'block', position: 'relative', width: size, height: size, overflow: 'hidden', boxSizing: 'border-box', border: `2px solid ${on ? ink : 'transparent'}`, background: '#111' }}>
              {renderPreview?.(key)}
            </span>
            <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: '.14em', opacity: on ? 1 : 0.6 }}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
